export default "__VITE_ASSET__BRkdA3r4__"